import _Button from '@/component/atoms/Button/_Button/_Button'
import commonRepo from '@/repository/common.repo'

import { S } from './RequiredConfirmModal.style'

type Props = {
  onStart: () => void
}

const StartModal = ({ onStart }: Props) => {
  return (
    <S.Step0>
      <p className="title">
        <span>더 넓고 편해진</span> {commonRepo.appKorName}, 시작해볼까요?
      </p>
      <p className="description">
        선생님 더 넓고 쾌적해진 {commonRepo.appKorName}에서 한층 효율적인 수업 준비를 시작해보세요!
      </p>
      <_Button width="100%" theme="primary" className="start-button" onClick={onStart}>
        어떤게 달라졌어요?
      </_Button>
    </S.Step0>
  )
}

export default StartModal
